import React from "react";
import { ValueTableRuleBuilder } from "../ValueTableRuleBuilder";
import { getValueTableNumber } from "../Testing/TestDataSetup";
import { StoryNode } from "../../../../CommonUI/StoryBook/StoryData";

export const ValueTableNumberStories = [
    new StoryNode(
        () => {
            let ruleDefinition = getValueTableNumber();
            ruleDefinition.rows[0].cells[0].values = 20;

            return <ValueTableRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Value Table",
        "Number",
        "Value"
    ),

    new StoryNode(
        () => {
            let ruleDefinition = getValueTableNumber();
            ruleDefinition.rows[0].cells[0].values = [20, 30];

            return <ValueTableRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Value Table",
        "Number",
        "List"
    ),
];
